module.exports = __webpack_public_path__ + "static/media/tags combination - Copy.bc6a486e.jpg";